module.exports = __webpack_public_path__ + "img/06.15570ff4.png";